var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782",
    transform: "translate(-390 -540)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17243",
    "data-name": "Rectangle 17243",
    width: 24,
    height: 24,
    rx: 5,
    transform: "translate(390 540)",
    fill: "#9ac03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7429",
    "data-name": "Path 7429",
    d: "M7598-10078.263l4.448,4.448,9.717-9.717",
    transform: "translate(-7203.068 10630.673)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.d725a1f78ba63648cbc5857bace9abfa.svg";
export { ForwardRef as ReactComponent };